import { Component } from '@angular/core';

@Component({
  selector: 'app-route-outlet-passthrough',
  standalone: false,
  template: '<router-outlet></router-outlet>',
  styles: ''
})
export class RouteOutletPassthroughComponent {

}
